import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Pause.svg'

export const IconPause = IconSVG as IconComponent
